import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [expandedItems, setExpandedItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setExpandedItems(prev => 
      prev.includes(index) 
        ? prev.filter(item => item !== index)
        : [...prev, index]
    );
  };

  const faqItems: FAQItem[] = [
    {
      question: "What makes junior mining stocks high-risk, high-reward?",
      answer: "Junior mining stocks are high-risk, high-reward because they're typically micro-cap companies exploring unproven deposits. While most juniors fail to find economic mineralization, those that do can deliver 10x, 100x, or even 1000x returns. The risk comes from exploration uncertainty, financing challenges, and market volatility. However, successful discoveries can transform small investments into life-changing wealth."
    },
    {
      question: "How does Rob's analysis mitigate speculation risks?",
      answer: "Rob's analysis mitigates risks through decades of experience in both engineering and finance. He evaluates geological potential, management track records, financing structures, and market timing. His insider knowledge helps identify companies with genuine discovery potential while avoiding overhyped promotions. Rob's systematic approach focuses on companies with strong technical merit and competent management teams."
    },
    {
      question: "What tools does the mining community offer?",
      answer: "The mining community provides comprehensive tools including real-time market analysis, educational courses on due diligence, technical analysis frameworks, management assessment guides, and access to exclusive research. Members get direct access to Rob's insights, live Q&A sessions, and a network of experienced speculators. The community also offers proprietary checklists and evaluation frameworks to streamline your research process."
    }
  ];

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#F6F6F6] pt-20 pb-20">
      <div className="">
        {/* Header */}
        <div className="text-left mb-10 w-full lg:w-2/3">
        <h2 className="text-[30px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7">
            FAQ
          </h2>
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 ">
            New to junior mining investment? Our FAQ answers key questions:
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-[10px] p-6 shadow-sm"
            >
              <div 
                className="flex items-center justify-between cursor-pointer"
                onClick={() => toggleItem(index)}
              >
                <h3 className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] last:mb-0 ">
                  {item.question}
                </h3>
                <div className="flex-shrink-0">
                  <svg 
                    className={`w-6 h-6 text-[#000] transition-transform duration-300 ${
                      expandedItems.includes(index) ? 'rotate-45' : ''
                    }`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
              </div>
              
              {expandedItems.includes(index) && (
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <p className="text-[14px] md:text-[16px] text-[#000] leading-[1.6] font-[400]">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Separator Line */}
        <div className="mt-24 pt-8 border-t border-gray-300 -mb-14"></div>
      </div>
    </section>
  );
};

export default FAQ;
